/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Kb_Side_2Inputs */

const en_signin_kb_side_2 = /** @type {(inputs: Signin_Kb_Side_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing leaves the building without your approval: every outbound action goes through a review.`)
};

const id_signin_kb_side_2 = /** @type {(inputs: Signin_Kb_Side_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang terkirim keluar tanpa persetujuanmu: setiap aksi keluar lewat approval.`)
};

/**
* | output |
* | --- |
* | "Nothing leaves the building without your approval: every outbound action goes through a review." |
*
* @param {Signin_Kb_Side_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_kb_side_2 = /** @type {((inputs?: Signin_Kb_Side_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Kb_Side_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_kb_side_2(inputs)
	return en_signin_kb_side_2(inputs)
});